<template>

  <p v-if="error" class="error">{{ error }}</p>
  <div class="cell small-12">
    <h1>Occupational Pension Questionnaire</h1>
    <p>During your pre-engagement questionnaire you indicated that you have a requirement for your employees to pay contributions to an occupational pension scheme.</p>
    <p>Please complete the following questionnaire to provide us with the information we need to set up your occupational pension scheme within payroll.</p>
  </div>


</template>


<script setup>

import { ref } from 'vue'

const error = ref(null)


const props = defineProps({
  formData: Object,
  clientInvite: Object
})


const validateStep = () => {
  return true;
}



const executeStep = async () => {
  return true;
}


defineExpose({ validateStep, executeStep });

</script>